import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {useLocalStorage} from 'react-use';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import PreviousFinding from 'components/Question/PreviousFinding.js';
import AuditorEvaluationAnswerInput from '../Widget/Evaluation/Auditor/Input.js';
import AuditorEvaluationAnswerFormula from '../Widget/Evaluation/Auditor/Formula.js';
import AuditorEvaluationAnswerTable from '../Widget/Evaluation/Auditor/Table.js';
import {Loading} from 'components/Loading/loading';
import { textDecorationUpdate } from '@syncfusion/ej2-react-spreadsheet';

import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap';
import FormRepository from 'repository/Form.js';
import natsort from 'hooks/natsort.js';

function Auditor() {

	const history = useHistory();
	const {formId, employeeId} = useParams();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);


	const [schedule, setSchedule] = useState();
  const [criteria, setCriteria] = useState();
  const [answers, setAnswers] = useState([]);
  const [scores, setScores] = useState([]);
  const [readonly, setReadonly] = useState(false);

  const repository = new FormRepository(auth.token);

	const handleSubmit = async () => {

    try {
      // // Validate Score
      // const answered = await axios.get(
      //   `${process.env.REACT_APP_API_HOST}answers`,
      //   {
      //     params: {
      //       expand: `question,form.schedule`,
      //       FORM_ID: formId,
      //       all: textDecorationUpdate
      //     },
      //     headers: {Authorization: `Bearer ${auth.token}`},
      //   }
      // );

      // // validate all answer must be score
      // if (answered.data.items.find((answer) => (answer.INDEX_ID === null))) {

      //   setSwal({
      //     type: TYPES.ERROR,
      //     payload: {
      //       title: `Failed!`,
      //       message: `There is one or more answerd is not score, yet!`,
      //     }
      //   });
      //   return false;
      // }

      const onSuccessCallback = async () => {

        const data = {
          EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
          EVALUATE_BY: auth.employee.EMP_ID,
        };

        const response = await repository.update(formId, data);

        history.push(`/auditor/${employeeId}/audits/${schedule.SCHEDULE_ID}/evaluations`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Confirmation!`,
          message: `Are you sure to submit?`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
	}

	const fetchForm = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}forms/${formId}`,
        {
          headers: {Authorization: `Bearer ${auth.token}`},
          params: {
            expand: [
              `criteria,answers.answerAttachments`,
              `schedule.instrument.score.scoreIndices`,
              `schedule.auditee.department`,
              `answers.question`,
              `answers.previous.index`,
              `answers.previous.answerActions.actionType`,
              `answers.previous.answerActions.pics.employee`,
              `answers.previous.form.schedule.auditorTeams.employee`
            ].join(',')
          }
        }
      );

      //
      setSchedule(response.data.schedule);
      setCriteria(response.data.criteria);
      setAnswers(response.data.answers.sort((a, b) => natsort(a.question.QUESTION_CODE, b.question.QUESTION_CODE)));
      setScores(response.data.schedule.instrument.score.scoreIndices);

      //check status to readonly mode
      const statuses = [
        'EVALUATED',
        'VISITED',
        'APPROVED',
        'COMPLETED'
      ];

      if (statuses.find(status => status == response.data.schedule.SCHEDULE_STATUS)){
        setReadonly(true);
      }


    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

	useEffect(() => {
		fetchForm();

    const body = document.querySelector('#root');

    body.scrollIntoView({
        behavior: 'smooth'
    }, 200)
	}, []);

	return (
    <Container fluid>
      {swal}
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => history.push(`/auditor/${auth.employee.EMP_ID}/audits`)}>
          Audit
        </Breadcrumb.Item>
        <Breadcrumb.Item onClick={() => history.push(`/auditor/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/evaluations`)}>
          { schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Desk Evaluation
        </Breadcrumb.Item>
      </Breadcrumb>
      {!criteria && <Loading />}

			{criteria && (
				<Row>
					<Col md="12">
						<Card>
							<Card.Header>
								<Card.Title style={{fontWeight:'bold'}} as="h3">{criteria.CRITERIA_CODE}. {criteria.CRITERIA_LABEL}</Card.Title>
							</Card.Header>
							<Card.Body>
                <div style={{whiteSpace: 'pre-wrap', fontSize:'17px'}} dangerouslySetInnerHTML={{__html: criteria.CRITERIA_DESCRIPTION}} />
              </Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{answers && schedule && answers.map((answer, key) => {
        switch (answer.question.QUESTION_TYPE_ID) {
          case 1:
            return (
              <AuditorEvaluationAnswerInput
                key={key}
                scores={scores}
                answer={answer}
                isReadonly={readonly}
              >
                <PreviousFinding data={answer.previous} />
              </AuditorEvaluationAnswerInput>
            );
          case 2:
            return (
              <AuditorEvaluationAnswerFormula
                key={key}
                scores={scores}
                answer={answer}
                isReadonly={readonly}
              >
                <PreviousFinding data={answer.previous} />
              </AuditorEvaluationAnswerFormula>
            );
          case 3:
            return (
              <AuditorEvaluationAnswerTable
                key={key}
                scores={scores}
                answer={answer}
                schedule={schedule}
                isReadonly={readonly}
              >
                <PreviousFinding data={answer.previous} />
              </AuditorEvaluationAnswerTable>
            );
        }
      })}


      <Row style={{ justifyContent: 'flex-end' }}>
        <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
          <Button
            onClick={handleSubmit}
            variant="success"
            disabled={readonly}
          >
            Submit
          </Button>{' '}
        </Col>
      </Row>
    </Container>
  );
}


export default Auditor;